import {ObjectDTO} from "../object-dto";
import {EquipementANettoyerPmsDto} from "./equipement-a-nettoyer-pms-dto";

export default class ZoneANettoyerPmsDto  extends ObjectDTO {
  libelle: string;
  imageData: File;
  equipementPmsList: EquipementANettoyerPmsDto[];
}
